module.exports = __webpack_public_path__ + "static/media/dream-home-blog.8c34d06e.png";